import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

//@ts-ignore
import style from "./TabNavigation.module.css";

// Handlers
import ComponentErrorHandler from "./ComponentErrorHandler";

interface ITabNavigation {
  views: {
    name: string;
    nameIcon?: Element;
    component: JSX.Element;
    onChange?: () => void;
  }[];
  initialView?: number;
}

export interface TabNavigationRef {
  changeView: (index: number) => void;
}

const TabNavigation: React.FC<ITabNavigation> = forwardRef<
  TabNavigationRef,
  ITabNavigation
>(({ views, initialView = 0 }, ref) => {
  const [selectedView, setSelectedView] = useState(views[initialView]);

  ComponentErrorHandler({ views });

  const handleViewClick = (viewName) => {
    setSelectedView(viewName);
  };

  useEffect(() => {
    selectedView.onChange && selectedView.onChange();
  }, [selectedView]);

  useImperativeHandle(ref, () => ({
    changeView: (index: number) => {
      if (!views[index]) return;
      handleViewClick(views[index]);
    },
  }));

  return (
    <div className={style.screenContent}>
      <div className={style.navigationContainer}>
        {views.map((view, index) => {
          const uniqueKey = `${view.name}-${index}`;
          return (
            <button
              className={`${style.navigationButton} ${
                selectedView.name === view.name
                  ? style.navigationButtonActive
                  : ""
              }`}
              onClick={() => handleViewClick(view)}
              key={uniqueKey}
            >
              <p>{view.name}</p>
              {view.nameIcon && view.nameIcon}
            </button>
          );
        })}
      </div>
      <div className={style.componentContainer}>{selectedView.component}</div>
    </div>
  );
});

export default TabNavigation;
